<script>
export default {
  props: ['lattlast'],
};
</script>

<template>
  <li v-if="lattlast.url" class="lattlast-button">
    <a :href="lattlast.url" :aria-label="lattlast.title">
      <i aria-hidden="true" class="material-icons">{{ lattlast.icon }}</i>
      <span>{{ lattlast.title }}</span>
    </a>
  </li>
</template>
